var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFarm = function SvgFarm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.417 54.583h49.166M37.4 54.559l-29.5.049-.025-36.728a4.93 4.93 0 0 1 2.188-4.08l9.833-6.564a4.902 4.902 0 0 1 5.458 0l9.833 6.563a4.869 4.869 0 0 1 2.188 4.081L37.4 54.56ZM49.617 54.608V44.75M49.667 30a4.931 4.931 0 0 0-4.917 4.917v4.916a4.931 4.931 0 0 0 4.917 4.917 4.931 4.931 0 0 0 4.916-4.917v-4.916A4.931 4.931 0 0 0 49.667 30ZM7.875 34.917h29.5M22.625 54.583v-9.218",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.625 26.313a3.687 3.687 0 1 0 0-7.375 3.687 3.687 0 0 0 0 7.375Z",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgFarm;